import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { Alert } from '@vio/atlas/Alert';
import { ButtonLink } from '@vio/atlas/ButtonLink';
import { Icon } from '@vio/atlas/Icon';
import { Text } from '@vio/atlas/Text';
import { getAnchorHotelCheapestOffer } from 'modules/sapiSearch/selectors';
import { getClickedOfferRate, getPreferredRate } from 'modules/search/selectors';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity } from '@daedalus/core/src/analytics/types/Events';
import { FormattedMessageWrapper } from '@daedalus/core/src/localization/components/FormattedMessage';
import { PriceDifferenceReason } from './PriceDifferenceReason';
import { calculatePriceDifference } from './utils';
const _exp = /*#__PURE__*/() => Alert;
const AlertWrapper = /*#__PURE__*/styled(_exp())({
  name: "AlertWrapper",
  class: "a1vd6g56",
  propsAsIs: true
});

/**
 * Added as part of 366b54ed-price-difference-alert-meta-traffic
 */

export const PriceDifferenceAlert: React.FC = () => {
  const dispatch = useDispatch();
  const [isVisible, setIsVisible] = useState(false);
  const [showPriceDifferenceReason, setShowPriceDifferenceReason] = useState(false);
  const anchorHotelCheapestOffer = useSelector(getAnchorHotelCheapestOffer);
  const clickedOfferRate = useSelector(getClickedOfferRate);
  const preferredRate = useSelector(getPreferredRate);
  const offer = anchorHotelCheapestOffer;
  const {
    totalRate = 0
  } = offer || {};
  const {
    isPriceIncreased,
    priceDifference
  } = calculatePriceDifference({
    rate: preferredRate || clickedOfferRate,
    totalRate
  });
  const eventTrackPayload = useMemo(() => ({
    clickedOfferRate,
    preferredRate,
    offer,
    priceDifference
  }), [priceDifference, offer, clickedOfferRate, preferredRate]);
  const handleOnClick = (status: boolean) => {
    if (status) {
      dispatch(trackEvent({
        category: Category.User,
        entity: Entity.PriceDifferenceAlert,
        action: Action.Clicked,
        payload: eventTrackPayload
      }));
    }
    setShowPriceDifferenceReason(status);
  };
  useEffect(() => {
    setIsVisible(Boolean(priceDifference));
  }, [priceDifference]);
  useEffect(() => {
    if (isVisible) {
      dispatch(trackEvent({
        category: Category.System,
        entity: Entity.PriceDifferenceAlert,
        action: Action.Displayed,
        payload: eventTrackPayload
      }));
    }
  }, [isVisible, eventTrackPayload, dispatch]);
  if (!isVisible) return null;
  return <>
      <AlertWrapper variant="warning" icon={<Icon size="sm" name={isPriceIncreased ? 'CustomTrendingUp' : 'CustomTrendingDown'} />}>
        <Text variant="bodyS">
          {isPriceIncreased ? <FormattedMessageWrapper id="priceDifferenceAlert.priceIncrease" defaultMessage="The price of this stay has gone up since we last checked." /> : <FormattedMessageWrapper id="priceDifferenceAlert.priceDecrease" defaultMessage="The price of this stay has gone down since we last checked." />}
          <ButtonLink variant="default" size="md" onClick={() => handleOnClick(true)} isCompact className="__priceDifferenceReasonButton">
            <FormattedMessageWrapper id="why" defaultMessage="Why?" />
          </ButtonLink>
        </Text>
      </AlertWrapper>
      <PriceDifferenceReason onClose={() => handleOnClick(false)} isOpen={showPriceDifferenceReason} />
    </>;
};

require("./PriceDifferenceAlert.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./PriceDifferenceAlert.tsx");